export default __webpack_public_path__ + "static/media/spanishClosed.faf358b5.jpg";